// Show the mobile choice shortcut only outside the purchase controls.
// Keep it above Shopify's optional draft bar.
// No variant, cart, tracking or checkout behavior is changed.
(() => {
  const shortcut = document.querySelector('.b2c-sticky-choice');
  if (!shortcut) return;
  let frame;
  const choice = document.querySelector('.b2c-product-choice');
  const mobile = matchMedia('(max-width:749px)');
  let pending = false;
  const rendered = element => element.getBoundingClientRect().height > 0;
  const update = () => {
    pending = false;
    if (!mobile.matches || !choice) { shortcut.hidden = false; return; }
    const start = [...choice.querySelectorAll('b2c-walk-builder,kit-variant-picker')].find(rendered) || choice;
    const buy = [...choice.querySelectorAll('.b2c-mixed-atc,.add-to-cart')].find(rendered);
    if (!buy) { shortcut.hidden = false; return; }
    const header = document.querySelector('.site-header');
    const headerBottom = Math.max(0, Math.min(120, header?.getBoundingClientRect().bottom || 0));
    const viewportBottom = innerHeight - Math.min(64, Math.max(0, frame?.getBoundingClientRect().height || 0));
    shortcut.hidden = start.getBoundingClientRect().top < viewportBottom && buy.getBoundingClientRect().bottom > headerBottom;
  };
  const schedule = () => {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  };
  addEventListener('scroll', schedule, {passive:true});
  addEventListener('resize', schedule, {passive:true});
  mobile.addEventListener('change', schedule);
  if (choice) {
    new ResizeObserver(schedule).observe(choice);
    new MutationObserver(schedule).observe(choice, {childList:true,subtree:true,attributes:true,attributeFilter:['hidden','class']});
  }
  const resize = new ResizeObserver(() => {
    shortcut.style.bottom = `${Math.min(64, Math.max(0, frame?.getBoundingClientRect().height || 0))}px`;
    schedule();
  });
  const connect = () => {
    const next = document.getElementById('PBarNextFrame');
    if (!next || next === frame) return;
    if (frame) resize.unobserve(frame);
    frame = next;
    resize.observe(frame);
  };
  connect();
  new MutationObserver(connect).observe(document.body, { childList: true });
  schedule();
})();

// A closer view of the existing photo follows the native selected variant.
// It reads native form changes and never submits or changes a product choice.
if (!customElements.get('b2c-collar-detail')) {
  customElements.define('b2c-collar-detail', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.b2c-product');
      this.image = this.querySelector('.b2c-collar-detail-image');
      this.colour = this.querySelector('[data-detail-colour]');
      this.variants = JSON.parse(this.querySelector('[data-detail-variants]').textContent);
      this.controller = new AbortController();
      this.root.addEventListener('change', event => {
        if (!event.target.matches('input[name="id"]')) return;
        const photo = this.variants[event.target.value];
        if (!photo) return;
        this.image.removeAttribute('srcset');
        this.image.src = photo.src;
        this.image.alt = `${this.root.querySelector('h1')?.textContent.trim() || ''} — ${photo.colour}`;
        this.colour.textContent = photo.colour;
      }, {signal: this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

// Collar size is a deliberate choice. The size rendered first is not treated as
// chosen until the visitor taps a size, unless the page was opened on a specific variant.
(() => {
  const root = document.querySelector('.b2c-product[data-size-gate]');
  const picker = root?.querySelector('kit-variant-picker');
  if (!picker) return;
  const sizeField = () => picker.querySelector('.astra-collar-breed-hint')?.closest('fieldset') || [...picker.querySelectorAll('fieldset')].pop();
  root.dataset.sizeChosen = String(new URLSearchParams(location.search).has('variant'));
  root.addEventListener('click', event => {
    if (root.dataset.sizeChosen === 'true') return;
    if (event.target.closest('input[type="radio"]') && sizeField()?.contains(event.target)) { root.dataset.sizeChosen = 'true'; return; }
    if (!event.target.closest('block-buy-buttons [name="add"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const field = sizeField();
    if (!field) return;
    field.scrollIntoView({block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    field.classList.remove('b2c-size-attention');
    requestAnimationFrame(() => field.classList.add('b2c-size-attention'));
    field.querySelector('input[type="radio"]')?.focus({preventScroll: true});
  }, {capture: true});
  // Keyboard submission follows the same rule as the button.
  root.addEventListener('submit', event => {
    if (root.dataset.sizeChosen === 'true' || !event.target.matches('block-buy-buttons form')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, {capture: true});
})();

// The mobile shortcut follows the size gate: once a size is chosen it reads "Add to cart" and adds directly
// through the main button (same cart logic, set offer included). Before that it keeps scrolling to the choice.
(() => {
  const root = document.querySelector('.b2c-product[data-size-gate]');
  const link = document.querySelector('.b2c-sticky-choice');
  const label = link?.querySelector('.b2c-sticky-cta');
  if (!root || !label) return;
  const initial = label.textContent;
  const added = document.documentElement.lang.startsWith('fr') ? 'Ajouter au panier' : document.documentElement.lang.startsWith('de') ? 'In den Warenkorb' : 'Add to cart';
  const button = () => root.querySelector('block-buy-buttons [name="add"]');
  const ready = () => root.dataset.sizeChosen === 'true' && root.dataset.offerReady !== 'false' && button() && !button().disabled;
  const sync = () => { label.textContent = ready() ? added : initial; };
  new MutationObserver(sync).observe(root, {attributes: true, attributeFilter: ['data-size-chosen', 'data-offer-ready']});
  link.addEventListener('click', event => {
    if (!ready()) return;
    event.preventDefault();
    button().click();
  });
  sync();
})();

// The size named beside the Bed and Nest price follows the native selection.
(() => {
  const label = document.querySelector('.b2c-product [data-b2c-heading-size]');
  const picker = label?.closest('.b2c-product').querySelector('kit-variant-picker');
  if (!picker) return;
  const sync = () => {
    const text = [...picker.querySelectorAll('fieldset')][1]?.querySelector('input[type="radio"]:checked + .kit-button')?.textContent.replace(/\s+/g, ' ').trim();
    if (text && label.textContent !== text) label.textContent = text;
  };
  new MutationObserver(sync).observe(picker, {childList: true, subtree: true});
  sync();
})();
